import {omneticApi} from '@dms/api/base';

import {
  UploadLicensePlateRemovalFileApiArg,
  UploadLicensePlateRemovalFileApiArgSchema,
  UploadLicensePlateRemovalFileApiResponse,
  UploadLicensePlateRemovalFileApiResponseSchema,
  CreateOfferSettingApiArg,
  CreateOfferSettingApiArgSchema,
  CreateOfferSettingApiResponse,
  CreateOfferSettingApiResponseSchema,
  UpdateOfferSettingApiArg,
  UpdateOfferSettingApiArgSchema,
  UpdateOfferSettingApiResponse,
  GetOfferSettingApiArg,
  GetOfferSettingApiArgSchema,
  GetOfferSettingApiResponse,
  OfferSettingResponseBodySchema,
  DeleteOfferSettingApiArg,
  DeleteOfferSettingApiArgSchema,
  DeleteOfferSettingApiResponse,
} from './types';

export const salesContextSettingsApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    uploadLicensePlateRemovalFile: build.mutation<
      UploadLicensePlateRemovalFileApiResponse,
      UploadLicensePlateRemovalFileApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/settings/background-removal/license-plate-file/upload`,
        method: 'POST',
        body: queryArg.uploadLicensePlateRemovalFileRequestBody,
      }),
      extraOptions: {
        requestSchema: UploadLicensePlateRemovalFileApiArgSchema,
        responseSchema: UploadLicensePlateRemovalFileApiResponseSchema,
      },
    }),
    createOfferSetting: build.mutation<CreateOfferSettingApiResponse, CreateOfferSettingApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/settings/offer`,
        method: 'POST',
        body: queryArg.createOfferSettingRequestBody,
      }),
      extraOptions: {
        requestSchema: CreateOfferSettingApiArgSchema,
        responseSchema: CreateOfferSettingApiResponseSchema,
      },
      invalidatesTags: [{type: 'OfferSetting', id: 'LIST'}],
    }),
    getOfferSetting: build.query<GetOfferSettingApiResponse, GetOfferSettingApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/settings/offer/${queryArg.settingId}`,
      }),
      extraOptions: {
        requestSchema: GetOfferSettingApiArgSchema,
        responseSchema: OfferSettingResponseBodySchema,
      },
      providesTags: (result, error, queryArg) => [{type: 'OfferSetting', id: queryArg.settingId}],
    }),
    updateOfferSetting: build.mutation<UpdateOfferSettingApiResponse, UpdateOfferSettingApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/settings/offer/${queryArg.settingId}`,
        method: 'PUT',
        body: queryArg.updateOfferSettingRequestBody,
      }),
      extraOptions: {
        requestSchema: UpdateOfferSettingApiArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        {type: 'OfferSetting', id: queryArg.settingId},
        {type: 'OfferSetting', id: 'LIST'},
      ],
    }),
    deleteOfferSetting: build.mutation<DeleteOfferSettingApiResponse, DeleteOfferSettingApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/settings/offer/${queryArg.settingId}`,
        method: 'DELETE',
      }),
      extraOptions: {
        requestSchema: DeleteOfferSettingApiArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        {type: 'OfferSetting', id: queryArg.settingId},
        {type: 'OfferSetting', id: 'LIST'},
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useUploadLicensePlateRemovalFileMutation,
  useCreateOfferSettingMutation,
  useGetOfferSettingQuery,
  useUpdateOfferSettingMutation,
  useDeleteOfferSettingMutation,
} = salesContextSettingsApi;
